import { render } from "./JournalFirst.vue?vue&type=template&id=91f98d10&scoped=true"
import script from "./JournalFirst.vue?vue&type=script&lang=js"
export * from "./JournalFirst.vue?vue&type=script&lang=js"

import "./JournalFirst.vue?vue&type=style&index=0&id=91f98d10&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91f98d10"]])

export default __exports__